(() => {
  const triggerSelector = '[data-mega-menu-trigger]';

  function activateCollection(trigger) {
    const grid = trigger.closest('.mega-menu__grid');
    if (!grid) return;

    const key = trigger.getAttribute('data-mega-menu-trigger');
    const panels = grid.querySelectorAll('[data-mega-menu-panel]');
    let found = false;

    panels.forEach((panel) => {
      const active = panel.getAttribute('data-mega-menu-panel') === key;
      panel.hidden = !active;
      if (active) found = true;
    });

    if (!found) return;

    grid.querySelectorAll(triggerSelector).forEach((item) => {
      item.setAttribute('aria-current', item === trigger ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.(triggerSelector);
    if (trigger) activateCollection(trigger);
  });

})();